import { styled } from '@mui/material';

export const ErrorContainer = styled('div')(({ theme }) => ({
    padding: theme.spacing(4),
    paddingTop: theme.spacing(12),
    textAlign: 'center',
    height: '100%',
    display: 'block',
}));
